import PageBar from "../../components/dashboard/page-bar/PageBar";
import SortJobTypes from "../../components/job-types/sortJobType/SortJobType";

function SortJobTypesPage() {
  return (
    <>
      <PageBar title="Sort Job Types" />

      <SortJobTypes />
    </>
  );
}
export default SortJobTypesPage;
